var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPath1039(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "105.52pt",
    height: "48.691pt",
    viewBox: "0 0 105.52 48.691",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.004 16.688h70.867v-2.8203h-70.867z",
    fill: "#ed1b27"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m0.25003 42.77c0 3.1328 2.5391 5.6719 5.668 5.6719h93.684c3.1289 0 5.668-2.5391 5.668-5.6719v-36.848c0-3.1289-2.5391-5.6719-5.668-5.6719h-93.684c-3.1289 0-5.668 2.543-5.668 5.6719z",
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m14.492 35.684h76.535v-22.676h-76.535z",
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath1039);
export default __webpack_public_path__ + "static/media/path1039.a3af6d3b7dfb7e6ab352e08e677d5d9f.svg";
export { ForwardRef as ReactComponent };